import * as React from "react";
import { Col } from "react-bootstrap";
import { IDividerLineProps } from "./interfaces";

const DividerLine: React.SFC<IDividerLineProps> = ({ ...props }) => (
  <div className="line-state">
    <Col
      xsOffset={props.xsOffset}
      xs={props.xs}
      smOffset={props.smOffset}
      sm={props.sm}
      mdOffset={props.mdOffset}
      md={props.md}
    >
      <div className="line" />
    </Col>
  </div>
);

export default DividerLine;



// WEBPACK FOOTER //
// ./src/components/common/DividerLine.tsx